import {initCalculator} from './initCalculator';
import {initRangeOne} from './initRangeOne';
import slideshow from './Slideshow/index';

function main()
{
	initRangeOne();
	initCalculator();
	slideshow();
}

/**
 * Module
 */
export {
	main as default,
};


//////////////////
// WEBPACK FOOTER
// ./app/Routes/Mortgage/index.js
// module id = s+nl
// module chunks = 0